export default {
  DEFAULT_LOGGER_STORE: 'by-logger',
  STORE_PV: 'by-pv',
  STORE_EVENT: 'by-events',
  STORE_SIGNUP: 'by-signup'
};